import axios from 'axios';

export default {
    list() {
        return axios.post('/repair/list/');
    },
};
